import { Slide } from '@/components/core/Slide';
import audioFile from './18-labor-market.mp3';

const autoNextDuration = 54000;
const transcript = `
  Laat me de arbeidsmarkt in de technieksector analyseren. We zien momenteel een enorme groei in de vraag 
  naar technisch personeel. Dit komt vooral door de sterke economische groei en de energietransitie die 
  gaande is.

  De cijfers zijn veelzeggend: er staan op dit moment meer dan tachtigduizend vacatures open in technische beroepen. 
  Dit is een structureel tekort dat we niet zomaar kunnen oplossen.

  Daarnaast hebben we te maken met vergrijzing in de sector. Veel ervaren technici gaan de komende jaren 
  met pensioen, terwijl er te weinig jongeren zijn die voor technische opleidingen kiezen.

  We zien ook dat de inhoud van technische banen sterk verandert door digitalisering. Dit creëert 
  nieuwe functies en vraagt om andere vaardigheden.

  Bedrijven zullen actief moeten inzetten op omscholing en innovatie om hier 
  optimaal van te profiteren.
`;

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1 className="text-3xl font-bold mb-8">🛠️ Arbeidsmarkt</h1>
        <ul className="space-y-4 list-disc">
          <li>Enorme groei door economie en energietransitie</li>
          <li>80.000 technische vacatures open</li>
          <li>Vergrijzing: veel pensioneringen, weinig instroom</li>
          <li>Banen veranderen door digitalisering</li>
          <li>AI en automatisering creëren meer kansen</li>
        </ul>
      </div>
    </Slide>
  );
};
